import * as types from './actionTypes';
import api from '../../../api/';

export function getAllBoards() {
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const boards = await api.getBoard();
      dispatch({
        type: types.LOADED,
        boards,
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function getBoard() {
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const board = await api.getBoard();
      dispatch({
        type: types.LOADED,
        board,
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function addBoard(json) {
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      await api.addBoard(json);
      dispatch({
        type: types.LOADED,
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function deleteBoard() {
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const cities = await api.getCities();
      dispatch({
        type: types.LOADED,
        cities,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
